export const environment = {
    pageName: 'El Paso CMS',
    appFlavor: 'elpaso',
    production: true,
    appEnv: 'prod',
    googleMapsKey: '',
    apiConfig: {
        projectEndpoint: 'https://api.elpasointernationalairport.com',
        apiKey: '0aa58381-4aa8-48ba-bc0b-a75611c7b71a',
    },
    firebase: {
        apiKey: 'AIzaSyD2Of6MKNYenKXHTDYBcE4kXecVT-EUbXk',
        authDomain: 'elpaso-paxassist.firebaseapp.com',
        databaseURL: 'https://elpaso-paxassist-default-rtdb.firebaseio.com',
        projectId: 'elpaso-paxassist',
        storageBucket: 'elpaso-paxassist.appspot.com',
        messagingSenderId: '278148428608',
        appId: '1:278148428608:web:268a7f2cc175607de780a5',
        measurementId: 'G-R9B02R10NF',
    },
    googleAnalyticsTrackId: '',
    rolesWithLoginAccess: [
        {
            role: 'admin',
            route: 'dashboard/content/users',
            node: 'users',
        },
        {
            role: 'power_user',
            route: 'dashboard/content/attractions',
            node: 'attractions',
        },
        {
            role: 'viewer',
            route: 'dashboard/content/attractions',
            node: 'attractions',
        },
    ],
    sessionTokenCheckInterval: 300000,
    getAllFlightsListInterval: 300000,
    sessionTokenExtension: true,
    defaultRoute: 'dashboard/content/users',
    enableRandomBackground: false,
    isGoogleAnalyticEnabled: false,
    airportCoordinates: {
        latitude: 31.80531216145772,
        longitude: -106.3824336070223,
        ISO3166_1_Alpha_2: 'US',
    },
    videoCategories: [],
    userTableLanguages: [{ key: 'en', label: 'LANGUAGES.ENGLISH_ONLY' }],
    userTablesRole: [
        { key: 'admin', label: 'ROLES.ADMIN' },
        { key: 'power_user', label: 'ROLES.POWER_USER' },
        {
            key: 'viewer',
            label: 'ROLES.VIEWER',
        },
    ],
    formLanguages: [
        { key: 'en', title: 'LANGUAGES.ENGLISH', label: 'FORMS.EN_LANG' },
        { key: 'es', title: 'LANGUAGES.ESPANOL', label: 'FORMS.ES_LANG' },
    ],
    appCategories: [],
    payment_method: [],
    payment_status: [],
    orientationArray: [],
    containerType: [],
    contentType: [],
    contentItems: [],
    equipmentType: [],
    departureTime: [],
    sectors: [],
    cartItems: [],
};
